/* global axios */
import ApiClient from './ApiClient';

class MetaIntegrationConfigAPI extends ApiClient {
  constructor() {
    super('meta_integration_config', { accountScoped: true });
  }

  updateConfig(data) {
    return axios.patch(this.url, data);
  }
}

export default new MetaIntegrationConfigAPI();
